/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { arr_inArray, htmlspecialchars, mj_create_unique_id, split_once } from './util.js';
import { showErrorToast } from './snackbar.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';

import { MDLocale } from './locale-impl.js';

import { MCUnknown } from './media.unknown.js';
import { MViewLinkUtil } from './media-view-link-util.js';
import { MThumbnails } from './thumbnails.js';

import { disableMediaViewBGCtrlsToolbar, setupMediaViewBGCtrlsToolbar } from './media-view-bg-ctrls-toolbar.js';
import { ToolbarSetupUtil } from './media-view-toolbar-util.js';

import { lazySizesConfig } from '../other/lazysizes.configuration.js';

export let MCVideo = function($,mj) {

	var media_class = 2;
	var video_pixfmts_alpha = {
		'RGBA':1,
		'GRAY_ALPHA':1,
		'YCbCr_ALPHA':1,
	};
	var video_suffixes = {
		'video/mp4':	'm4v',
		'video/webm':	'webm',
		'video/ogg':	'ogv',
		'video/x-flv':	'flv',
		'video/MP2P':	'mpg',
		'video/MP1S':	'mpeg',
	};

	var video_format_display_names;

	var m_test_video = null;
	var m_test_cache = {};


	// $(function() {
	// 	// translations are available on DOMContentLoaded ..
	// 	video_format_display_names = {
	// 		'video/mp4':	mjt('md-video-mp4'),
	// 		'video/webm':	mjt('md-video-webm'),
	// 		'video/ogg':	mjt('md-video-ogg'),
	// 		'video/x-flv':	mjt('md-video-flv'),
	// 		'video/MP2P':	mjt('md-video-mpeg2ps'),
	// 		'video/MP1S':	mjt('md-video-mpeg1ss'),
	// 	};

	// 	// TODO: make this a lazy init ..
	// 	MViewLinkUtil.init();
	// });

	// determine whether browser supports playback of given preview format
	function can_play( pf ) {
		const html5_mime_type = pf.html5_mime_type;
		if( m_test_cache.hasOwnProperty(html5_mime_type) ) {
			return m_test_cache[html5_mime_type];
		}
		if( !m_test_video ) {
			m_test_video = document.createElement('video');
		}
		if( !m_test_video || !m_test_video.canPlayType ) {
			return false;
		}
		const r = m_test_video.canPlayType(html5_mime_type);
		return m_test_cache[html5_mime_type] = r=='maybe' || r=='probably';
	}

	function get_pf_display_name( pf ) {
		var html5_mime_type = pf.html5_mime_type;
		var tmp = split_once(html5_mime_type,';');
		var ctype = tmp[0];
		if( video_format_display_names.hasOwnProperty(ctype) ) {
			return video_format_display_names[ctype];
		}
		return html5_mime_type;
		// return ctype;
	}

	function set_time_on_src( src, time ) {
		if( typeof src !== 'string' ) {
			if( typeof src === 'undefined' || src===null ) {
				return '';
			}
			src = src.toString();
		}
		var fnp = src.lastIndexOf('/') + 1,
			dp = src.lastIndexOf('.'),
			a, aa;
		if( dp!==-1 ) {
			a = src.substr(fnp,dp-fnp).split('_');
			aa = time ? [a[0],a[1],a[2],a[3],time] : [a[0],a[1],a[2],a[3]];
			//console.log(['set_time_on_src',src,fnp,dp,time,aa, src.substr(0,fnp), aa.join('_'), src.substr(dp) ]);
			return src.substr(0,fnp) + aa.join('_') + src.substr(dp);
		}
		return src;
	}
	function set_time_on_srcset( srcset, time ) {
		if( typeof srcset === 'undefined' || srcset===null ) {
			return '';
		}
		var a = srcset.split(/,\s*/),
			i, l = a.length,
			src, sp;
		for( i=0; i<l; ++i ) {
			src = a[i];
			if( (sp=src.lastIndexOf(' '))===-1 ) {
				a[i] = set_time_on_src(src,time);
			} else {
				a[i] = set_time_on_src(src.substr(0,sp),time) + src.substr(sp);
			}
		}
		return a.join(', ');
	}
	function set_img_srcs( img, src, srcset ) {
		img.attr( {
			src,
			srcset,
			'data-src': src,
			'data-srcset': srcset
		} );
	}
	function next_frame(next) {
		var self = $(this),
			ft = $.data(this,'frametimes');
		if( ft && ft.length ) {
			var cf = $.data(this,'curframe');
			if( ++cf >= ft.length ) {
				cf = 0;
			}
			$.data(this,'curframe',cf);
			var new_src = set_time_on_src($.data(this,'src'),ft[cf]);
			var new_srcset = set_time_on_srcset($.data(this,'srcset'),ft[cf]);

			set_img_srcs(self.children('img'),new_src,new_srcset);
			self
				.delay(1000,'MCVideoThumbQue')
				.queue('MCVideoThumbQue',next_frame);
			next();
		}
	}
	function init_anim( trg ) {
		var img_elm = $(trg).children('img');
		$.data(trg,'curframe',0);
		$.data(trg,'src',img_elm.attr('data-src'));
		var img_attr_srcset = img_elm.attr('data-srcset');
		if( img_attr_srcset ) {
			$.data(trg,'srcset',img_attr_srcset);
		}
	}
	function start_anim( trg ) {
		var $trg = $(trg), $trg_img=$trg.children('img');
		$trg_img.removeClass(lazySizesConfig.lazyClass+' '+lazySizesConfig.loadedClass+' '+lazySizesConfig.loadingClass+' '+lazySizesConfig.unloadClass).addClass('video-flipbooking');
		$.data(trg,'curframe',0);
		$(trg)
			.stop('MCVideoThumbQue',true,false)
			.queue('MCVideoThumbQue',next_frame)
			.dequeue('MCVideoThumbQue');
	}
	function stop_anim(trg) {
		var $trg = $(trg), $trg_img=$trg.children('img');
		$trg.stop('MCVideoThumbQue',true,false);
		set_img_srcs($trg_img,$.data(trg,'src'),$.data(trg,'srcset'));
		$trg_img.addClass(lazySizesConfig.loadedClass+' '+lazySizesConfig.unloadClass);
		requestAnimationFrame( function() {
			$trg_img.removeClass('video-flipbooking');
		} );
	}

	function VideoDetailPreview( dtinfo, target, xopts, toolbarSetupUtil ) {

		var md_trg = $(target),
			media_id = dtinfo.media_id,
			meta = dtinfo.meta,
			md_closed = false,
			// viewport dimensions
			md_view_w = Math.max(10,md_trg.width()-10),
			md_view_h = Math.max(10,md_trg.height()-10),
			// original video dimensions
			md_src_w = meta[200] ? parseInt(meta[200][0],10) : 640,
			md_src_h = meta[201] ? parseInt(meta[201][0],10) : 480,
			// previous display dimensions - used to avoid superfluous reloads
			md_prev_dsp_w = -1,
			md_prev_dsp_h = -1,
			// available preview formats & the currently selected one
			m_available_preview_formats = {},
			m_pf_ids_sorted = [],
			md_cur_pf_id = -1;

		// available after "mjstoolbarsetup"
		var md_vfmt_select=null, md_vfmt_loading=null, md_vfmt_progress=null;

		// state for links between multiple views
		var md_view_link = false;
		var md_view_link_id = 0;
		var md_view_link_other_ids = [];
		// eslint-disable-next-line no-unused-vars
		var md_view_linked_from_id = 0;

		if( xopts.view_link_available ) {
			md_view_link_id = (xopts.view_link_group_pfx||'') + MViewLinkUtil.getNextLinkTargetId();
		}

		var md_video = null;
		var md_view_ctrls = null;
		var _rebuildVideoPreviewDOM = function() {
			// cleanup
			md_trg
				.off('.mjVideoDetailPreview .mjVDPViewLink')
				.removeClass('md-view-link-trg-linked md-view-link-trg-initiated')
				.toggleClass('md-view-link-trg-avl',!!xopts.view_link_available);
			// setup html
			md_trg.html( '<div class="md-video"></div>'
						+'<div class="md-view-ctrls" style="display:none">'
						+ ( xopts.view_link_available
							? (	 '<div title="'+mjt('md-view-link-on')+'" class="md-view-ctrl md-view-link-on"></div>'
								+'<div title="'+mjt('md-view-link-off')+'" class="md-view-ctrl md-view-link-off"></div>' )
							: '' )
						+'</div>' );

			md_video = md_trg.find('> .md-video');
			md_video.prop('id',mj_create_unique_id('md_video_'));
			md_view_ctrls = md_trg.children('.md-view-ctrls');
		};

		_rebuildVideoPreviewDOM();

		var md_video_seeked_callbacks_arr = [];
		var md_video_suppress_events = false;

		function _selectPreviewFormatById( id, update_select ) {
			if( id === md_cur_pf_id ) {
				// no change ..
				return false;
			}
			md_cur_pf_id = id;
			if( md_vfmt_select && update_select ) {
				md_vfmt_select.val(md_cur_pf_id).trigger('change.select2');
			}
			if( md_cur_pf_id!==-1 ) {
				md_trg.triggerHandler('mjspreviewformatchanged',m_available_preview_formats[md_cur_pf_id]);
			}
			return true;
		}

		function close_handler( unbind ) {
			if( md_video ) {
				const html5_video = md_video.children('.video');
				if( html5_video.length ) {
					// firefox does not always stop the video when its detached from DOM, so manually stop it now
					if( html5_video[0].pause ) {
						html5_video[0].autobuffer = false;
						html5_video[0].preload = 'none';
						html5_video[0].pause();
					}
				}
				md_video.empty();
			}
			if( unbind ) {
				md_trg.off('.mjVideoDetailPreview .mjVDPViewLink');
				md_closed = true;
			}
			md_trg.removeClass('md-video-canvas');
			if( unbind && xopts.view_link_available ) {
				$(document).triggerHandler('mjsviewlinkgotlost',[md_view_link_id]);
			}
		}

		function update_view_ctrls() {
			// update view-link switches
			md_view_ctrls
				.children('.md-view-link-on').toggle( !!md_view_link ).end()
				.children('.md-view-link-off').toggle( !md_view_link ).end()
				.toggle( !!xopts.view_link_available );
		}


		function show_preview( force_update, auto_play, from_canvas_resize, on_try_select_pf_for_view ) {
			// console.log({'func':'show_preview',md_view_link_id,media_id,dtinfo_media_id:dtinfo.media_id});
			var cur_pf = m_available_preview_formats[md_cur_pf_id] || null;
			// viewport dimensions
			const view_w = md_view_w;
			const view_h = md_view_h;
			// video dimensions
			var src_w = md_src_w;
			var src_h = md_src_h;

			if( cur_pf != null ) {
				src_w = cur_pf.vid_width;
				src_h = cur_pf.vid_height;
				// if no actual video stream exists in preview ..
				if( src_w<=0 ) {
					src_w = 400;
				}
				if( src_h<=0 ) {
					src_h = 225;
				}
			}

			// determine display dimensions (if video is larger than available viewport)
			const dsp_dim = MThumbnails.getImageDimsScaledToBox2(view_w,view_h,src_w,src_h,false);
			const dsp_w = dsp_dim[0];
			const dsp_h = dsp_dim[1];
			const dsp_dim_scaled = dsp_dim[2]; // -1=down, 0=none, +1=up

			if( !force_update && md_video && md_prev_dsp_w==dsp_w && md_prev_dsp_h==dsp_h && dsp_dim_scaled===0 ) {
				if( on_try_select_pf_for_view && from_canvas_resize ) {
					// may call on_try_select_pf_for_view() below ...
					// on_try_select_pf_for_view();
				} else {
					// re-center the player and return
					// nothing to do anymore ...
					return;
				}
			}
			md_prev_dsp_w = dsp_w;
			md_prev_dsp_h = dsp_h;

			// save current play status & position
			var cur_time = 0;
			var cur_paused = true;
			var cur_ended = false;
			const cur_html5_video = md_video && md_video.children('.video');
			if( cur_html5_video && cur_html5_video.length ) {
				cur_paused = cur_html5_video[0].paused;
				cur_ended = cur_html5_video[0].ended;
				cur_time = cur_html5_video[0].currentTime;
				if( cur_ended ) {
					cur_time = 0;
				}

				if( from_canvas_resize ) {
					// console.log({w:'show_preview() with from_canvas_resize=true ...',cur_paused,cur_ended,cur_time});
					if( cur_paused || cur_ended ) {
						if( on_try_select_pf_for_view ) {
							// try to select a format which is more appropriate to current view size ...
							const format_changed = on_try_select_pf_for_view();
							if( format_changed ) {
								// format actually changed ... must update preview now:
								return show_preview(true,false,true);
							}
						}
					}

					// keep current media element(s)
					// .. at least while its playing ...
					if( !xopts.in_annotation_view ) {
						md_video.css('min-height',dsp_h+'px');
					}
					md_video.find('>.md-video-inner').css( {
						width: dsp_w+'px',
						height: dsp_h+'px',
					} );
					cur_html5_video
						.attr('width',Math.floor(dsp_w))
						.attr('height',Math.floor(dsp_h));

					return;
				}
			}

			// remove previous player instance(s)
			close_handler(false);

			// add new player instance ...

			if( cur_pf===null ) {
				if( force_update ) {
					// no format available -> show custom preview or icon or something similar ...
					return MCUnknown.createPreview(dtinfo,target,xopts);
				}
				// show_preview() was probably called tooo early.. try again
				return;
			}

			// add outer container
			md_trg.addClass('md-video-canvas');
			var mdv_css = {};
			var poster_src;
			if( !xopts.no_poster_bg ) {
				const poster_fill = false;
				poster_src = MCVideo.getPosterImageSrc(dtinfo,dsp_w,dsp_h,poster_fill);
				mdv_css['background-image'] = 'url('+poster_src+')';
			}
			if( !xopts.in_annotation_view ) {
				mdv_css['min-height'] = dsp_h+'px';
			}

			md_video_seeked_callbacks_arr = [];
			md_video_suppress_events = false;

			md_video
				.css(mdv_css)
				.html('<div class="md-video-inner" style="width:'+dsp_w+'px; height:'+dsp_h+'px" title="'+mjt('md-video-click')+'"></div>');

			const src1 = mj.webroot+'media/file/stream_preview/id/'+media_id+'_'+md_cur_pf_id;
			const vq3 = !dtinfo.is_latest_version ? '?version='+encodeURIComponent(dtinfo.version) : '';

			md_video.html(	 '<video class="video"'
								+' width="'+Math.floor(dsp_w)+'" height="'+Math.floor(dsp_h)+'"'
								+(xopts.no_poster_bg?'':' poster="'+htmlspecialchars(poster_src,true,true)+'"')
								+' controls'
								+' autobuffer'
								+' preload="auto"'
								+' allowfullscreen="allow"'
								+' playsinline'	// ios-specific !?
								+(auto_play?' autoplay':'')
								+'>'
								+  '<source src="' + mj.fixAssetURL(src1+'.'+cur_pf.sfx+vq3) + '" type=\''+cur_pf.html5_mime_type+'\'>'
								+  mjt('md-no-video-support')+'<br><br><a href="' + mj.fixAssetURL(src1+'.m4v'+vq3) + '">'+mjt('md-no-video-support-download')+'</a>'
								+'</video>' );
			var new_html5_video = md_video.children('.video');

			// setup event handlers for syncing/linking ...
			var video = new_html5_video[0];

			new_html5_video.on('play.mjVideoDetailPreview playing.mjVideoDetailPreview abort.mjVideoDetailPreview emptied.mjVideoDetailPreview ended.mjVideoDetailPreview pause.mjVideoDetailPreview', function(evt) {
				if( !md_view_link ) {
					return;
				}
				if( md_video_suppress_events ) {
					return;
				}

				const playing = !( video.paused || video.ended );
				const position = video.currentTime;
				//console.log({evt,md_view_link_id,playing,position});
				md_trg.triggerHandler( 'mjsafterseekto', [ playing, position, 'from video evt '+evt.type+' ('+md_view_link_id+')' ] );
			} );

			new_html5_video.on('seeked.mjVideoDetailPreview', function(evt) {
				if( !md_view_link ) {
					return;
				}
				const still_suppress_events = !!md_video_suppress_events;

				// callbacks for when seek is done:
				while( md_video_seeked_callbacks_arr.length ) {
					var cbs = md_video_seeked_callbacks_arr;
					md_video_seeked_callbacks_arr = [];
					while( cbs.length ) {
						const cb = cbs.shift();
						if( cb ) {
							cb();
						}
					}
				}
				if( still_suppress_events || md_video_suppress_events ) {
					return;
				}

				const playing = false;	//!( video.paused || video.ended );
				const position = video.currentTime;
				//console.log({evt,md_view_link_id,playing,position});
				md_trg.triggerHandler( 'mjsafterseekto', [ playing, position, 'from video evt '+evt.type+' ('+md_view_link_id+')' ] );
			});



			// restore play status & position
			if( cur_time > 0 ) {
				new_html5_video[0].load();
				new_html5_video[0].currentTime = cur_time;
				if( cur_paused ) {
					new_html5_video[0].pause(); // ignore auto_play argument ??
				}
			}

			new_html5_video[0].addEventListener( 'loadedmetadata', function(e) {
				md_trg.triggerHandler('mjslayoutchanged',e.type);
			}, true );
			new_html5_video[0].addEventListener( 'loadeddata', function(e) {
				md_trg.triggerHandler('mjslayoutchanged',e.type);
				//md_trg.triggerHandler( 'mjsafterseekchanged' );
			}, true );
			new_html5_video[0].addEventListener( 'error', function(e) {
				const media_error = new_html5_video[0].error;
				const error_str = media_error ? ( media_error.message + ' (code='+media_error.code+')' ) : 'unknown';
				showErrorToast('Video error: '+error_str);
			}, true );

			if( xopts.setup_html5mediaelem ) {
				xopts.setup_html5mediaelem(new_html5_video[0],cur_pf);
			}

			if( xopts.view_link_available ) {
				trigger_view_link_handlers();
			}

			// update view-link switches
			update_view_ctrls();

		} // show_preview()


		function build_sorted_preview_formats( available_preview_formats ) {
			// sort the formats
			let pf_ids_sorted = [];
			for( const pf_id in available_preview_formats ) {
				if( !available_preview_formats.hasOwnProperty(pf_id) ) {
					continue;
				}
				available_preview_formats[pf_id].id = pf_id;
				pf_ids_sorted.push(pf_id);
			}
			pf_ids_sorted.sort( function(a,b) {
				if( available_preview_formats[a].vid_height == available_preview_formats[b].vid_height ) {
					const amxg = available_preview_formats[a].mux_xgroup || '99-unknown';
					const bmxg = available_preview_formats[b].mux_xgroup || '99-unknown';
					return amxg.localeCompare(bmxg);
				}
				return available_preview_formats[b].vid_height - available_preview_formats[a].vid_height;
			} );
			return pf_ids_sorted;
		}

		function prepare_preview_formats( available_preview_formats, pf_ids_sorted, on_playable_fmt_cb ) {
			for( var idx=0; idx<pf_ids_sorted.length; idx++ ) {
				const pf_id = pf_ids_sorted[idx];
				let pf = available_preview_formats[pf_id];
				if( pf.media_class != media_class ) {
					continue; // skip non-video previews
				}
				pf.vid_width = parseInt(pf.vid_width,10);
				pf.vid_height = parseInt(pf.vid_height,10);
				// add commly queried properties to preview format..
				pf.sfx = ( pf.mux_file_sfx ? pf.mux_file_sfx : video_suffixes[pf.format] ) || 'bin';
				pf.html5_mime_type = pf.mux_html5_type ? pf.mux_html5_type : ( pf.mux_mime_type ? pf.mux_mime_type : pf.format );
				// can browser play this format ?
				pf.browser_can_play = can_play(pf);
				if( pf.browser_can_play ) {
					if( on_playable_fmt_cb ) {
						on_playable_fmt_cb(pf_id,pf);
					}
				}
			}
		}

		function select_preview_format_for_view( available_preview_formats, pf_ids_sorted, cur_pf_id, md_view_w, md_view_h, allow_formats_smaller_than_cur ) {
			let new_pf_id = cur_pf_id;
			for( var idx=0; idx<pf_ids_sorted.length; idx++ ) {
				const pf_id = pf_ids_sorted[idx];
				if( pf_id == cur_pf_id ) {
					continue;
				}
				const pf = available_preview_formats[pf_id];
				if( pf.media_class != media_class ) {
					continue; // skip non-video previews
				}
				if( !pf.browser_can_play ) {
					continue; // skip incompatible formats
				}
				if( new_pf_id==-1 ) {
					// select first one..
					new_pf_id = pf_id;
				} else {
					// select this format if it fits better than current one
					const cur_pf = available_preview_formats[new_pf_id];
					if( pf.browser_can_play && !cur_pf.browser_can_play ) {
						// prefer supported video
						new_pf_id = pf_id;
					} else if( pf.browser_can_play==cur_pf.browser_can_play ) {
						// if both are supported or both are not supported, then ...
						if( pf.vid_width<=md_view_w && pf.vid_height<=md_view_h ) {
							// prefer, if it fits into viewport..
							if( pf.vid_width>cur_pf.vid_width || pf.vid_height>cur_pf.vid_height ) {
								// ..and is larger than current
								new_pf_id = pf_id;
							} else if( cur_pf.vid_width>md_view_w || cur_pf.vid_height>md_view_h ) {
								// ..or the current one did not fit into viewport
								if( allow_formats_smaller_than_cur ) {
									new_pf_id = pf_id;
								}
							}
						} else if( cur_pf.vid_width>md_view_w || cur_pf.vid_height>md_view_h ) {
							// ..or the current one did not fit into viewport
							if( allow_formats_smaller_than_cur ) {
								new_pf_id = pf_id;
							}
						}
					}
				}
			}
			return new_pf_id;
		}


		// bind handlers
		md_trg
			.off('.mjVideoDetailPreview')
			.on( 'mjsclose.mjVideoDetailPreview', function(e) {
				close_handler(true);
			} )
			.on( 'mjsresize.mjVideoDetailPreview', function(e,w,h) {
				// save new viewport dimensions
				md_view_w = Math.max(10,w-10);
				md_view_h = Math.max(10,h-10);

				// show
				show_preview(
					false,
					false,
					true,
					function _on_try_select_pf_for_view() {
						// try to find a format that is "more" appropriate for current view ... ?
						const new_pf_id = select_preview_format_for_view(
							m_available_preview_formats,
							m_pf_ids_sorted,
							md_cur_pf_id,
							md_view_w,
							md_view_h,
							false
						);
						if( _selectPreviewFormatById(new_pf_id,true) ) {
							return true;
						}
						return false;
					}
				);
			} )
			.on( 'mjstoolbarsetup.mjVideoDetailPreview', function(e,toolbar,is_triggered_here) {
				// console.log({w:'video: on mjstoolbarsetup',e,toolbar,is_triggered_here});

				// toolbar setup handler
				function init_with_preview_formats( j ) {
					m_available_preview_formats = j;

					// if download permission is available, then add source file to preview formats selection
					if( dtinfo.r_download ) {
						const src_format = meta[-2]&&meta[-2][0] ? meta[-2][0] : 'application/octet-stream';
						const src_vid_codec = meta[304]&&meta[304][0] ? meta[304][0] : 'unknown';
						//const src_aud_codec = meta[404]&&meta[404][0] ? meta[404][0] : '???';
						const playable_hack = ( src_format=='video/mp4' || src_format=='video/quicktime' )
								? (	// MP4 is playable when following conditions are met:
									src_vid_codec=='h264' || src_vid_codec=='H.264/AVC'					// is h.264/avc ?
									&& ( meta[306] && meta[306][0] && meta[306][0]==1 )					// and 'progressively loadable' (=moov atom before mdat atom) ?
								) : true;																// non-MP4-files are harmless - the following code will filter that, depending on browser's video support
						if( playable_hack ) {
							m_available_preview_formats[0] = {
								media_class:	media_class,
								sort:			-1,
								format:			src_format,
								name:			mjt('md-video-format-original'),
								file_size: 		meta[5]&&meta[5][0] ? meta[5][0] : -1,

								mux_xgroup:		'00-org',
								vid_codec:		src_vid_codec,
								vid_width:		md_src_w,
								vid_height:		md_src_h,
								vid_duration:	meta[300]&&meta[300][0] ? meta[300][0] : -1,
								vid_framerate:	meta[301]&&meta[301][0] ? meta[301][0] : -1,
								vid_rotation:	meta[229]&&meta[229][0] ? meta[229][0] : 0,

								aud_codec:		meta[404]&&meta[404][0] ? meta[404][0] : 'unknown',
								aud_duration:	meta[400]&&meta[400][0] ? meta[400][0] : -1,
								aud_channels:	meta[401]&&meta[401][0] ? meta[401][0] : -1,
								aud_samplerate:	meta[403]&&meta[403][0] ? meta[403][0] : -1,
							};
						}
					}

					m_pf_ids_sorted = build_sorted_preview_formats(m_available_preview_formats);

					prepare_preview_formats(
						m_available_preview_formats,
						m_pf_ids_sorted,
						function _playable_fmt_cb( pf_id, pf ) {
							// add to selection
							// var fmt_dur = MDLocale.fmt_duration(pf.vid_duration,true),
							const fmt_fps = MDLocale.fmt_float_plain(pf.vid_framerate,3,true);
							var pf_text = pf.vid_width+'x'+pf.vid_height+' '+get_pf_display_name(pf)+' @'+fmt_fps+' fps';
							if( mj.debug ) {
								if( pf.hasOwnProperty('aud_channels') && pf.aud_channels>0 ) {
									const fmt_chs = pf.aud_channels==2 ? 'Stereo' : ( pf.aud_channels==1 ? 'mono' : pf.aud_channels+' channels' );
									const fmt_sr = pf.aud_samplerate + 'Hz';
									pf_text += ' '+fmt_chs+' '+fmt_sr;
								}
								if( pf.hasOwnProperty('file_size') && pf.file_size ) {
									pf_text += ' sz='+MDLocale.fmt_filesize(pf.file_size,true);
								}
							}
							if( pf.name ) {
								pf_text += ' ('+pf.name+')';
							}
							$('<option/>').attr('value',pf_id).text(pf_text).appendTo(md_vfmt_select);
						}
					);

					const new_pf_id = select_preview_format_for_view(
						m_available_preview_formats,
						m_pf_ids_sorted,
						md_cur_pf_id,
						md_view_w,
						md_view_h,
						true
					);

					if( mj.debug ) {
						$('<button type="button" class="tiny-debug"><span class="label">debug info</span></button>')
							.click( function() {
								var dbg_info = [];
								for( var dbg_idx=0; dbg_idx<m_pf_ids_sorted.length; dbg_idx++ ) {
									const dbg_pf_id = m_pf_ids_sorted[dbg_idx];
									const dbg_pf = m_available_preview_formats[dbg_pf_id];
									dbg_info.push(
										{
											id: dbg_pf_id,
											name: dbg_pf.name,
											mux_html5_type: dbg_pf.mux_html5_type ? dbg_pf.mux_html5_type : ( dbg_pf.mux_mime_type ? dbg_pf.mux_mime_type : dbg_pf.format ),
											wxh: dbg_pf.vid_width+'x'+dbg_pf.vid_height,
											sz: dbg_pf.file_size ? MDLocale.fmt_filesize(dbg_pf.file_size,true) : 'unknown',
										}
									);
								}
								var xPageDebug = window.MVPageDebug;
								if( window.parent && window.parent.MVPageDebug ) {
									xPageDebug = window.parent.MVPageDebug;
								}
								xPageDebug.reset();
								xPageDebug.dprint_data( 'Video previews debug info', dbg_info );
								xPageDebug.dprint_data( 'Available video preview formats', m_available_preview_formats );
								xPageDebug.dprint_html( '', 'footer', '' );
							})
							.insertAfter(md_vfmt_select);
					}

					_selectPreviewFormatById(new_pf_id,true);

					md_vfmt_loading.remove();
					md_vfmt_progress.remove();
					if( md_vfmt_select.children('option').length==0 ) {
						md_vfmt_select.replaceWith( '<span>'+mjt('md-video-no-preview-available')+'</span>' );
					} else {
						md_vfmt_select
							.val(md_cur_pf_id)
							.show()
							.change( function() {
								// switch to selected preview format
								_selectPreviewFormatById(this.options[this.selectedIndex].value,false);
								show_preview(true,true);
								// set focus to media elem (so, e.g. pressing SPACE will play/pause)
								$(this).blur();
								if( md_video ) {
									md_video.find('.video').focus();
								}
							});
					}
				} // init_with_preview_formats

				function init_query_preview_progress( prioritize_counter ) {
					// check server-side progress...
					$.postJSON('json/media/meta-mprevprogress', 'media_id='+encodeURIComponent(media_id)+(prioritize_counter==0?'&prioritize=1':''), function(j) {
						if( j && ( j.hasOwnProperty('p') || j.retry ) ) {
							// in progress.. (either post import or delayed post import)
							// show/update progress info..
							md_vfmt_loading.remove();
							const percent = j.hasOwnProperty('p') ? 0.1 * j.p : 0.0;
							const progress_indicator = md_vfmt_progress.show();
							const avl_width = progress_indicator.find('.outer').width()||0;
							progress_indicator.find('.inner').css('width',Math.round(avl_width*percent/100.0)+'px');
							// re-query
							setTimeout( function() {
								if( !md_closed ) {
									init_query_preview_progress( prioritize_counter==9 ? 0 : prioritize_counter+1 );
								}
							}, 4000 );
						} else {
							// not in progress.. -> try to get preview formats, but don't further check progress information
							init_query_preview_formats(false);
						}
					});
				}

				function init_query_preview_formats( query_progress ) {
					if( dtinfo.is_latest_version ) {
						if( query_progress ) {
							init_query_preview_progress(0);
						} else {
							// get available preview formats
							$.postJSON('json/media/meta-mprevfmts', 'media_id='+encodeURIComponent(media_id)+'&media_class='+media_class, function(j) {
								if( j ) {
									init_with_preview_formats(j);
								} else {
									md_vfmt_loading.remove();
									md_vfmt_progress.remove();
								}
								show_preview(true,false);
							});
						}
					} else {
						// show - even without any preview formats (with some luck, we can playback the original file)
						md_vfmt_loading.remove();
						md_vfmt_progress.remove();
						show_preview(true,false);
					}
				}

				// add custom control with preview format selection
				const md_vfmt_select_id = mj_create_unique_id('md-vfmt-select-');
				$('.left-edge',toolbar).after(
					'<td class="section md-vid-ctrls-1 md-preview-ctrl-elems">'
						+ '<label for="'+md_vfmt_select_id+'">'+mjt('md-video-select-format')+'</label>'
						+ '<select id="'+md_vfmt_select_id+'" class="md-vfmt-select" style="display:none"></select>'
						+ '<span class="md-vfmt-loading">'+mjt('md-video-loading-formats')+'</span>'
						+ '<span class="md-vfmt-progress" style="display:none">'+mjt('md-video-preview-generating')+'<br /><span class="outer"><span class="inner"></span></span></span>'
					+'</td>'
					+'<td class="separator md-preview-ctrl-elems"></td>' );
				md_vfmt_select = $('.md-vfmt-select',toolbar);
				md_vfmt_loading = $('.md-vfmt-loading',toolbar);
				md_vfmt_progress = $('.md-vfmt-progress',toolbar);

				// get available preview formats - if n/a, then start querying progress information..
				init_query_preview_formats(true);
			} );




		function set_view_seek( playing, position, do_trigger ) {
			if( do_trigger ) {
				md_trg.triggerHandler( 'mjsbeforeseekchanged', [playing,position] );
			}
			if( !md_video ) {
				return;
			}
			var new_html5_video = md_video.children('.video');
			if( new_html5_video[0] ) {
				var video = new_html5_video[0];
				md_video_suppress_events = true;

				// var _stage2 = function() {
				// 	var cur_playing = !( video.paused || video.ended );
				// 	if( playing && !cur_playing ) video.play();
				// 	else if( !playing && cur_playing ) video.pause();
				// 	md_video_suppress_events = false;
				// };

				if( Math.abs(video.currentTime-position) >= 0.16 ) {
					// seek
					//md_video_seeked_callbacks_arr.push(_stage2);		// dont allow seek + play yet (streams always pause after seek. thats it)
					md_video_seeked_callbacks_arr.push( function() {
						md_video_suppress_events = false;
					} );
					if( !video.paused ) {
						video.pause();
					}
					video.currentTime = position;
					// NOTE: ... the video will receive a 'seeked' event when the seek succeeded
				} else {
					// alter play state ?
					var cur_playing = !( video.paused || video.ended );
					if( playing !== cur_playing ) {
						if( playing ) {
							video.play();
						} else {
							video.pause();
						}
					}
					md_video_suppress_events = false;
				}

			}
			if( do_trigger ) {
				md_trg.triggerHandler( 'mjsafterseekchanged', [playing,position] );
			}
		}

		function setup_view_link_handlers() {
			md_trg
				.on( 'mjsviewlinkotherbecameavailable.mjVideoDetailPreview', function( e, vlti, other_elem ) {
					if( arr_inArray(vlti,md_view_link_other_ids)===-1 ) {
						md_view_link_other_ids.push(vlti);
						if( xopts.hasOwnProperty('view_link_auto_on_count') && (md_view_link_other_ids.length+1)==xopts.view_link_auto_on_count ) {
							// establish view link only after ALL required other previews became active ...
							if( md_trg.is('.md-view-link-trg-linked,.md-view-link-trg-initiated') ) {
								// another view link has already established
							} else {
								// but only when no other view link became active earlier
								//console.log([ md_view_link_id,md_view_link_other_ids,   'link_view initiating (X)' ]);
								set_view_link(true,false);
							}
						}
					}
				} )
				.on( 'mjsviewlinkothergotlost.mjVideoDetailPreview', function( e, vlti, other_elem ) {
					var i;
					if( (i=arr_inArray(vlti,md_view_link_other_ids))!==-1 ) {
						md_view_link_other_ids.splice(i,1);
					}
				} )
				.on('mjsbeforeviewlinkiset.mjVideoDetailPreview',function( e, vlti, state, from_elem ) {

					// console.log({ on:'mjsbeforeviewlinkiset', md_view_link_id, vlti, state, from_elem, from_elem_matches_md_trg: md_trg[0].isSameNode(from_elem),  e });

					md_view_link = state;
					md_view_linked_from_id = state ? vlti : 0;
					setup_view_link__from_linked_initiator(state,from_elem);
				} )
				.on('mjsafterviewlinkiset.mjVideoDetailPreview',function _on_mjsafterviewlinkiset_MCVideo( e, vlti, state, from_elem ) {

					// console.log({ on:'mjsafterviewlinkiset', md_view_link_id, vlti, state, from_elem, from_elem_matches_md_trg: md_trg[0].isSameNode(from_elem),  e });

					update_view_ctrls();
				} )
				.on( 'mjsviewlinkset.mjVideoDetailPreview', function( e, state ) {
					set_view_link(state,false);
				} )
				.on( 'mjsviewlinkupdate.mjVideoDetailPreview', function _on_mjsviewlinkupdate_MCVideo( e, sync_state ) {
					md_trg.triggerHandler('mjsseeksyncset',[sync_state,'from mjsviewlinkupdate ('+md_view_link_id+')']);
				} );
		}

		function trigger_view_link_handlers() {
			$(document).triggerHandler('mjsviewlinkbecameavailable',[md_view_link_id,md_trg[0]]);
		}

		function get_view_seek_state() {
			var md_playing = false;
			var md_position = 0;
			if( md_video ) {
				var new_html5_video = md_video.children('.video');
				if( new_html5_video[0] ) {
					var video = new_html5_video[0];
					md_playing = !( video.paused || video.ended );
					md_position = video.currentTime;
				}
			}
			return {
				md_playing: md_playing,
				md_position: md_position,
			};
		}

		function setup_view_link__from_linked_initiator( state, initiator_elem ) {
			var linked_trg = $(initiator_elem),
				initiator_trg = md_trg;

			linked_trg.off('.mjVDPViewLink');
			initiator_trg.off('.mjVDPViewLink');

			if( state ) {
				var _setup_a2b_and_b2a = function( a,b, fun ) {
					fun(a,b);
					fun(b,a);
				};
				_setup_a2b_and_b2a( linked_trg, initiator_trg, function( cv_A, cv_B ) {
					// sync'ed seek
					cv_A.on('mjsafterseekto.mjVDPViewLink',function( e, from_playing, from_position, dbg_src_info ) {

						// console.log({ msg:'mjsafterseekto', md_view_link_id, from_playing, from_position, dbg_src_info,    linked_trg, initiator_trg,    e });

						var sync_state = {
							md_playing: from_playing,
							md_position: from_position,
						};
						cv_B.triggerHandler('mjsseeksyncset',[sync_state,'from mjsafterseekto ('+md_view_link_id+')']);
					});
				} );

			}
		}

		function set_view_link( state_val, do_trigger ) {
			if( md_view_link===state_val ) {
				return;
			}

			var allavl_targets = MViewLinkUtil.getAvailableTargets(),
				linked_targets = allavl_targets.not(md_trg);

			linked_targets.trigger('mjsbeforeviewlinkiset',[md_view_link_id,state_val,md_trg[0]]);

			md_view_link = state_val;
			md_view_linked_from_id = state_val ? md_view_link_id : 0;

			if( state_val ) {
				allavl_targets.removeClass('md-view-link-trg-initiated');
				linked_targets.addClass('md-view-link-trg-linked');
				md_trg.removeClass('md-view-link-trg-linked')
					.addClass('md-view-link-trg-initiated');
			} else {
				allavl_targets.removeClass('md-view-link-trg-linked md-view-link-trg-initiated');
			}

			if( md_view_link ) {
				// push this views state once to all connected views
				linked_targets.triggerHandler('mjsviewlinkupdate',[get_view_seek_state()]);
			}
			linked_targets.trigger('mjsafterviewlinkiset',[md_view_link_id,md_view_link,md_trg[0]]);

			update_view_ctrls();
		}







		// setup click handlers
		md_view_ctrls
			.find('> .md-view-link-on').hide().click( function() {
				set_view_link(false,true);
				return false;
			} ).end()
			.find('> .md-view-link-off').hide().click( function() {
				set_view_link(true,true);
				return false;
			} ).end();


		// bind seek sync handler
		md_trg.on( 'mjsseeksyncset.mjVideoDetailPreview', function _mjsseeksyncset_MCVideo( e, sync_state, dbg_src_info ) {

			// console.log({ msg:'mjsseeksyncset', md_view_link_id, sync_state, dbg_src_info, e });

			set_view_seek(sync_state.md_playing,sync_state.md_position,false);
		});


		if( xopts.view_link_available ) {
			setup_view_link_handlers();
		}
	} // VideoDetailPreview


	return Object.assign( {}, MCUnknown, {

		init: function() {
			video_format_display_names = {
				'video/mp4':	mjt('md-video-mp4'),
				'video/webm':	mjt('md-video-webm'),
				'video/ogg':	mjt('md-video-ogg'),
				'video/x-flv':	mjt('md-video-flv'),
				'video/MP2P':	mjt('md-video-mpeg2ps'),
				'video/MP1S':	mjt('md-video-mpeg1ss'),
			};
			// TODO: make this a lazy init ..
			MViewLinkUtil.init();
		},

		createThumbnail: function( media_id, meta, target, iw, ih, version, on_load_cb ) {
			if( MCUnknown.createThumbnailCommon(media_class,media_id,meta,target,iw,ih,version,on_load_cb) ) {
				return;
			}
			var pixfmt = meta[203] ? meta[203][0] : '',
				mc = meta[-1] ? meta[-1][0] : media_class,
				sfx = (pixfmt=='' || pixfmt in video_pixfmts_alpha) ? 'png' : 'jpg',
				qry = '?m='+encodeURIComponent(meta[-4]?meta[-4][0]:'')								// add "modified datetime"
						+(version?'&v='+encodeURIComponent(version):'')								// add "version"
						+(meta[229]&&meta[229][0]?'&r='+meta[229][0]:''),							// add "rotation" to prevent caching issues
				src = mj.webroot+'media/file/thumb/id/'+media_id+'_'+mc+'_{iw}_{ih}.'+sfx+qry,
				xattrs = MCUnknown.createThumbnailDimAttrs(meta,iw,ih,false);
			var hovered = false;
			$(target).off('.MCVideo').stop('MCVideoThumbQue',true,true);
			MThumbnails.createResponsiveImgElem(
				target,
				src,
				{iw:iw,ih:ih},
				true,
				xattrs,
				'video',
				on_load_cb
			);
			init_anim(target);
			if( !version ) {
				// load further preview images on mouse over (but only for latest version thumbnails)
				$(target)
					.on('mouseenter.MCVideo',function() {
						if( hovered ) {
							return; // ignore this event
						}
						hovered = true;
						var trg = this,
							ft = $.data(trg,'frametimes');
						if( ft ) {
							// frametimes already loaded - start here immediately
							if( ft.length>1 ) {
								start_anim(trg); // start only if actually has multiple (more than one) frames
							}
						} else {
							// load frametimes
							$.data(trg,'frametimes',[]);
							$.postJSON('json/media/meta-mthumbframetimes','media_id='+encodeURIComponent(media_id),function(j) {
								if( j && j.length ) {
									$.data(trg,'frametimes',j);
									if( hovered ) {
										start_anim(trg);
									}
								}
							});
						}
					})
					.on('mouseleave.MCVideo',function() {
						hovered = false;
						var trg = this,
							ft = $.data(trg,'frametimes');
						if( ft && ft.length>1 ) {
							stop_anim(trg); // stop only if actually has multiple (more than one) frames
						}
					});
			}
		},

		getSourceDimensions: function( dtinfo ) {
			const meta = dtinfo.meta;
			const w = meta[200] ? parseInt(meta[200][0],10) : 640;
			const h = meta[201] ? parseInt(meta[201][0],10) : 480;
			const r = meta[230] ? parseFloat(meta[230][0])  : (w/h);
			return [w,h,r];
		},

		getPosterImageSrc: function( dtinfo, dsp_w, dsp_h, fill ) {
			const media_id = dtinfo.media_id;
			const meta = dtinfo.meta;
			const has_custom_preview = meta[10] && meta[10][0] > 0;
			const vq = !dtinfo.is_latest_version ? '&version='+encodeURIComponent(dtinfo.version) : '';
			const fq = fill ? '&fill=1&transparency=1&bg_color=00000000' : '';
			const rotation = meta[229] && meta[229][0] ? parseInt(meta[229][0],10) : 0;
			const rq = (rotation?'&rotate='+rotation:'');
			if( dsp_w===0 && dsp_h===0 ) {
				dsp_w = meta[200] ? parseInt(meta[200][0],10) : 640;
				dsp_h = meta[201] ? parseInt(meta[201][0],10) : 480;
			} else {
				dsp_w = Math.floor(dsp_w);
				dsp_h = Math.floor(dsp_h);
			}
			if( rotation==90 || rotation==270 ) {
				// swap display width & height
				const t = dsp_w;
				dsp_w = dsp_h;
				dsp_h = t;
			}
			return mj.fixAssetURL(
				has_custom_preview
					? mj.webroot+'media/file/custom_preview/id/'+media_id+'_'+media_class+'_0_'+dsp_w+'_'+dsp_h+'.png?cp_m='+encodeURIComponent(meta[12]?meta[12][0]:'')+'&m='+encodeURIComponent(meta[-4]?meta[-4][0]:'')+vq+fq+rq
					: mj.webroot+'media/file/preview/id/'+media_id+'_'+media_class+'_1_'+dsp_w+'_'+dsp_h+'.png?m='+encodeURIComponent(meta[-4]?meta[-4][0]:'')+vq+fq+rq
			);
		},

		getXodURL: function( dtinfo, vid_w, vid_h, force_xod ) {
			const media_id = dtinfo.media_id;
			const meta = dtinfo.meta;
			var has_custom_preview = meta[10] && meta[10][0] > 0;
			const vq = !dtinfo.is_latest_version ? '&version='+encodeURIComponent(dtinfo.version) : '';
			const fq = force_xod ? '&force_xod=1' : '';
			const rq = (meta[229]&&meta[229][0]?'&rotate='+meta[229][0]:'');
			if( vid_w===0 && vid_h===0 ) {
				vid_w = meta[200] ? parseInt(meta[200][0],10) : 640;
				vid_h = meta[201] ? parseInt(meta[201][0],10) : 480;
			}
			has_custom_preview = false; // not here
			return mj.fixAssetURL(
				has_custom_preview
					? mj.webroot+'media/file/custom_preview/id/'+media_id+'_'+media_class+'_0_'+vid_w+'_'+vid_h+'.xod?cp_m='+encodeURIComponent(meta[12]?meta[12][0]:'')+'&m='+encodeURIComponent(meta[-4]?meta[-4][0]:'')+vq+fq+rq
					: mj.webroot+'media/file/preview/id/'+media_id+'_'+media_class+'_1_'+vid_w+'_'+vid_h+'.xod?m='+encodeURIComponent(meta[-4]?meta[-4][0]:'')+vq+fq+rq
			);
		},

		createPreview: function( dtinfo, target, xopts ) {
			const md_trg = $(target);
			disableMediaViewBGCtrlsToolbar( md_trg );

			const has_custom_preview = dtinfo.meta[10] && dtinfo.meta[10][0] > 0;
			if( has_custom_preview ) {
				return MCUnknown.createPreview(dtinfo,target,xopts); // custom preview
			}
			let toolbarSetupUtil = new ToolbarSetupUtil();
			if( !xopts.no_bg_ctrls_toolbar ) {
				setupMediaViewBGCtrlsToolbar( md_trg, xopts, (toolbar) => toolbarSetupUtil.onToolbarSetup(toolbar) );
			}
			VideoDetailPreview(dtinfo,target,xopts,toolbarSetupUtil);
		},
	} );

}(jQuery,mj);

